import { useReducer } from 'react';

// Taken from here
// https://itnext.io/usefetch-react-custom-hook-for-fetch-api-with-suspense-and-concurrent-mode-in-mind-1d3ba9250e0
export const useForceUpdate = () => useReducer(state => !state, false);
